import React from 'react';
import { Form, Input, RequiredHelpPhrase, Row, SonForm, SubmitButton, TextParam, useForm } from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export type ExtrenalLinksForm = SonForm<TextParam<'name'> | TextParam<'url'>>;

type ExtrenalLinksAddOrUpdateFormProps = {
  form: ExtrenalLinksForm;
  refresh(): void;
};

export function ExternalLinksAddOrUpdateForm({ form, refresh }: ExtrenalLinksAddOrUpdateFormProps) {
  const { t } = useSonTranslation('ExternalLinks');

  const { formProps, params, fetchState } = useForm({
    form,
    onSuccess: refresh,
  });

  const nameParam = params.getByName('name');
  const urlParam = params.getByName('url');

  return (
    <Form id="external-links-form" {...formProps}>
      <RequiredHelpPhrase />
      <Row>
        <Input label={t('addOrUpdateForm.input.title')} param={nameParam} />
      </Row>
      <Row>
        <Input
          label={t('addOrUpdateForm.input.url')}
          helpText={t('addOrUpdateForm.input.urlHelpText')}
          param={urlParam}
        />
      </Row>
      <SubmitButton
        buttonLabel={t('phrases:saveChanges')}
        messageSuccess={t('addOrUpdateForm.status.success')}
        messageSending={t('addOrUpdateForm.status.sending')}
        messageFail={t('addOrUpdateForm.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
